import Glide from "@glidejs/glide";

(($) => {
  $(document).ready(function () {
    const $glide = $(".pillars__glide");
    if (!$glide.length) return;

    new Glide($glide[0], {
      type: "carousel",
      perView: 4,
      gap: 0,
      peek: { before: 0, after: 100 },
      focusAt: "center",
      breakpoints: {
        1440: { perView: 3, gap: 0, peek: { before: 0, after: 60 } },
        1103: {
          perView: 2,
          gap: 0,
          peek: { before: 0, after: 40 },
          focusAt: "center",
        },
        768: {
          perView: 1.2,
          gap: 0,
          peek: { before: 20, after: 40 },
          focusAt: "center",
        },
        506: {
          perView: 1.05,
          gap: 0,
          peek: { before: 15, after: 30 },
          focusAt: "center",
        },
      },
    }).mount();
  });
})(jQuery);
